export const EMAIL_TITLE_ANIMATION_DELAY = 0.44;
export const HERO_TEXT_ANIMATION_DELAY = 0.46;
export const SOCIAL_TITLE_ANIMATION_DELAY = 0.95;
